module.exports = __webpack_public_path__ + "media/images/landing/scroll_arrow-45c572936fdc3d2775a2b50370692bb3.png";